/* Modale de confirmation de suppression de compte — extraite tel quel de
 * AccountSettingsPage.tsx. Markup/backdrop identiques à l'original (conserve
 * son propre fond `bg-black/60` et le verrouillage de fermeture pendant le
 * chargement). */

export default function DeleteAccountModal({
  confirmation,
  onConfirmationChange,
  loading,
  error,
  phrase,
  onCancel,
  onConfirm,
}: {
  confirmation: string;
  onConfirmationChange: (value: string) => void;
  loading: boolean;
  error: string | null;
  phrase: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={() => !loading && onCancel()}
    >
      <div
        className="bg-cream-app rounded-3xl border-2 border-ink max-w-md w-full p-6 space-y-4"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center shrink-0">
            <svg className="w-5 h-5 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-slate-900">
              Suppression définitive du compte
            </h3>
            <p className="text-sm text-slate-600 mt-1">
              Cette action est <strong>irréversible</strong>. Toutes vos analyses, votre historique et votre profil seront effacés immédiatement.
            </p>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1.5">
            Pour confirmer, tapez exactement&nbsp;: <span className="font-mono text-red-600">{phrase}</span>
          </label>
          <input
            type="text"
            value={confirmation}
            onChange={e => onConfirmationChange(e.target.value)}
            disabled={loading}
            autoComplete="off"
            className="w-full px-3 py-2 text-sm bg-cream-app border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-red-500 text-slate-900 font-mono"
            placeholder={phrase}
          />
        </div>

        {error && (
          <p className="text-sm text-red-500">{error}</p>
        )}

        <div className="flex items-center justify-end gap-2 pt-2">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium rounded-lg text-slate-700 hover:bg-slate-100 transition-colors disabled:opacity-50"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={loading || confirmation !== phrase}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Suppression...' : 'Supprimer définitivement'}
          </button>
        </div>
      </div>
    </div>
  );
}
